import { useEffect, useState } from 'react';

/** Быстрый ответ — без лоадера, чтобы не мигать (`FAST_LOAD_THRESHOLD` монолита) */
const FAST_LOAD_THRESHOLD = 150;

/** Загрузка идёт дольше порога — тогда показываем лоадер поверх старых данных */
export function useIsSlowLoading(isLoading: boolean): boolean {
  const [isSlow, setIsSlow] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      return;
    }

    const timer = setTimeout(() => setIsSlow(true), FAST_LOAD_THRESHOLD);

    return () => {
      clearTimeout(timer);
      setIsSlow(false);
    };
  }, [isLoading]);

  return isLoading && isSlow;
}
